import { render, staticRenderFns } from "./edit-homeWork.vue?vue&type=template&id=239846ec&"
import script from "./edit-homeWork.vue?vue&type=script&lang=ts&"
export * from "./edit-homeWork.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports